import React from 'react';

/*
 * Exported from the Between DS. Filled rather than stroked, which is why these
 * sit apart from the outline set in the folder above - several of those names
 * are in use on other screens and must keep the drawing they have.
 *
 * The one change from the export: every fill is currentColor, so a row can
 * colour its own icon - see .sidebar-icon in side-nav.css. The exported size is
 * kept rather than forced square; two of these are not square, and the slot
 * caps them without stretching them.
 */

const BotsIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : '19'}
         height={props.height ? props.height : '16'}
         viewBox="0 0 19 16" fill="none"
    >
        <path d="M15.8333 5.83333V4.16667C15.8333 3.25 15.0833 2.5 14.1667 2.5H11.6667C11.6667 1.11667 10.55 0 9.16667 0C7.78333 0 6.66667 1.11667 6.66667 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V5.83333C1.11667 5.83333 0 6.95 0 8.33333C0 9.71667 1.11667 10.8333 2.5 10.8333V14.1667C2.5 15.0833 3.25 15.8333 4.16667 15.8333H14.1667C15.0833 15.8333 15.8333 15.0833 15.8333 14.1667V10.8333C17.2167 10.8333 18.3333 9.71667 18.3333 8.33333C18.3333 6.95 17.2167 5.83333 15.8333 5.83333ZM14.1667 14.1667H4.16667V4.16667H14.1667V14.1667ZM6.66667 9.16667C5.975 9.16667 5.41667 8.60833 5.41667 7.91667C5.41667 7.225 5.975 6.66667 6.66667 6.66667C7.35833 6.66667 7.91667 7.225 7.91667 7.91667C7.91667 8.60833 7.35833 9.16667 6.66667 9.16667ZM12.9167 7.91667C12.9167 8.60833 12.3583 9.16667 11.6667 9.16667C10.975 9.16667 10.4167 8.60833 10.4167 7.91667C10.4167 7.225 10.975 6.66667 11.6667 6.66667C12.3583 6.66667 12.9167 7.225 12.9167 7.91667ZM5.83333 10.8333H12.5V12.5H5.83333V10.8333Z" fill="currentColor"/>
    </svg>
);

export default BotsIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/nav/BotsIcon.jsx